import { render, staticRenderFns } from "./MenuItemGroup.vue?vue&type=template&id=cf92679c"
import script from "./MenuItemGroup.vue?vue&type=script&lang=js"
export * from "./MenuItemGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports